import { Button } from "../ui/button";
import { Navigation, Plus, Minus } from "lucide-react";

const MapControls = ({ onCenter, onZoomIn, onZoomOut, locationStatus }) => {
  return (
    <div className="absolute right-3 bottom-24 lg:bottom-auto lg:top-1/2 lg:-translate-y-1/2 flex flex-col gap-2 z-10">
      <Button
        size="icon"
        variant="secondary"
        className="w-14 h-14 rounded-2xl shadow-lg bg-white text-gray-700 hover:bg-gray-50 active:scale-95 transition-transform touch-target-lg border border-gray-200"
        onClick={onZoomIn}
        data-testid="map-zoom-in-btn"
      >
        <Plus className="w-6 h-6" />
      </Button>
      <Button
        size="icon"
        variant="secondary"
        className="w-14 h-14 rounded-2xl shadow-lg bg-white text-gray-700 hover:bg-gray-50 active:scale-95 transition-transform touch-target-lg border border-gray-200"
        onClick={onZoomOut}
        data-testid="map-zoom-out-btn"
      >
        <Minus className="w-6 h-6" />
      </Button>
      <Button
        size="icon"
        variant="secondary"
        className={`w-14 h-14 rounded-2xl shadow-lg bg-white text-gray-700 hover:bg-gray-50 active:scale-95 transition-transform touch-target-lg mt-2 border border-gray-200 ${
          locationStatus === "granted" ? "ring-2 ring-blue-500" : ""
        }`}
        onClick={onCenter}
        data-testid="map-center-btn"
        title="Center on my location"
      >
        <Navigation className={`w-6 h-6 ${locationStatus === "granted" ? "text-blue-500" : locationStatus === "detecting" ? "text-gray-400 animate-pulse" : "text-gray-700"}`} />
      </Button>
    </div>
  );
};

export default MapControls;
